import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { DealerBusinessService } from '../../../business-services/dealer.service';
import { OlbDealerViewModel } from '../../../business-entities/olb-dealer.model';

@Component({
  selector: 'app-get-dms-dealer',
  templateUrl: './get-dms-dealer.component.html'
})
export class GetDmsDealerComponent implements OnInit {

  lstDealers: OlbDealerViewModel[] = [];
  selectedDealer: OlbDealerViewModel;

  constructor(
    private dealerBusinessService: DealerBusinessService,
    private activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.OlbGetDealers();
  }
  OnDealerSelect(dealer: any) {
    this.selectedDealer = dealer;
  }
  OnClose(status: boolean) {
    this.activeModal.close({ success: status, dealer: this.selectedDealer });
  }
  async OlbGetDealers() {
    this.spinner.show();
    await this.dealerBusinessService.OlbGetDealers("").then((response) => {
      this.lstDealers = response;
    }).finally(() => {
      this.spinner.hide();
    });
  }
}
